import { makeVar, useReactiveVar } from "@apollo/client";
import { TagOfAssociation } from "../../../../../API";

export interface ILocationForm {
  locationName: string;
  referenceId: string;
  latitude: string;
  longitude: string;
  tags: TagOfAssociation[];
  rowId: string;
  timeZone: string;
}

export const defaultLocationFormVariables = {
  locationName: "",
  referenceId: "",
  latitude: "",
  longitude: "",
  tags: [],
  rowId: "",
  timeZone: "",
};

export const locationFormVariables = makeVar<ILocationForm>(
  defaultLocationFormVariables
);

export const useLocationFormVariables = () =>
  useReactiveVar(locationFormVariables);
